/*
 *
 * Alert mixin
 *
 * Mixin for Layout Views that have an alerts region
 *
 */

import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import AlertView from '@/views/alert_view';

    var Alert = Backbone.Model.extend();

    export default {
        /**
         * Show an alert within this view.
         * @param {string} message - a string message to put into the alert
         * @param {string} type - type of message: (success|info|warning|danger)
         * @param {number} timeout - Time in ms to wait before hiding the alert (omitted/undefined means don't hide)
         */
        alert: function(message, type, timeout) {
            var alert_rgn = this.getRegion('alerts');
            if (!alert_rgn) {
                console.warn('No alert region found');
                return;
            }

            var alert = new Alert({
                message: message,
                type: type,
                timeout: timeout
            });

            if (!alert_rgn.currentView) {
                var collection = new Backbone.Collection();
                var AlertCollectionView = Marionette.CollectionView.extend({
                    childView : AlertView
                });
                alert_rgn.show(new AlertCollectionView({collection: collection}));
            }

            alert_rgn.currentView.collection.add(alert);

        },
        /**
         * These 2 functions from Dialog Interface are Overwritten here.
         * Eventually, this should be mixed into DialogInterface.
         */
        showAlert: function(type, message) {
            this.alert(message, type);
        },
        hideAlert: function() {
            console.warn('Alert Mixin hideAlert');
        }
    };

